<template>
  <div ref="chart">
    <Chart :extendData="extendData" :height="height" :id="id" :option="option" :width="width"></Chart>
  </div>
</template>

<script>
import Chart from '@/components/echarts/Chart';

export default {
  name: "DynamicLineChart",
  components: {Chart},
  props: {
    data: {},
    extendData: null,
  },
  data() {
    return {
      id: "lineChart",
      width: '100%',
      height: '100%',
      option: {},
    };
  },
  watch: {
    data: {
      handler() {
        this.getOption();
      },
      deep: true
    },
  },
  mounted() {
    this.getOption()
  },
  methods: {
    getOption: function () {
      let labelColor = 'rgba(73, 164, 243, .2)';
      const colorList = ["#07E6F8", '#ECBB18'];
      const color0 = this.data.data && this.data.data[0] && this.data.data[0].color ? this.data.data[0].color : colorList[0];
      const color1 = this.data.data && this.data.data[1] && this.data.data[1].color ? this.data.data[1].color : colorList[1];
      this.option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            label: {
              show: false,
              backgroundColor: 'rgba(0,0,0,0)',
              color: '#556677',
              borderColor: 'rgba(0,0,0,0)',
              shadowColor: 'rgba(0,0,0,0)',
              shadowOffsetY: 0
            },
            lineStyle: {
              width: 0
            }
          },
          backgroundColor: 'rgba(0,0,0,0.5)',
          textStyle: {
            color: '#fff'
          },
          padding: [10, 10],
          extraCssText: 'box-shadow: 1px 0 2px 0 rgba(163,163,163,0.5)'
        },
        grid: {
          top: '25%',
          right: '15%',
          left: '15%',
          bottom: '20%',
          // containLabel: true
        },
        xAxis: [{
          type: 'category',
          splitNumber: 5,
          data: this.data.time,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            interval: 0,
            textStyle: {
              color: '#8DB0CB'
            },
            // 默认x轴字体大小
            fontSize: 12,
            // margin:文字到x轴的距离
            margin: 15
          },
          boundaryGap: false
        }],
        yAxis: [{
          name: this.data.data ? this.data.data[0].name + '(' + this.data.data[0].unit + ')' : '',
          type: 'value',
          nameTextStyle: {
            color: color0,
            fontSize: 12,
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false,
            // lineStyle: {
            //   color: colorList[0]
            // },
          },
          axisLabel: {
            textStyle: {
              color: color0
            },
            formatter: '{value}'
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: labelColor
            }
          },
        }, {
          name: this.data.data && this.data.data[1].name ? this.data.data[1].name + '(' + this.data.data[1].unit + ')' : '  ',
          type: 'value',
          nameTextStyle: {
            color: color1,
            fontSize: 12,
          },
          position: 'right',
          axisTick: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: color1
            },
            formatter: '{value}'
          },
          axisLine: {
            show: false,
            // lineStyle: {
            //   color: colorList[1]
            // },
          },
          splitLine: {
            show: false
          }
        }],
        series: [{
          name: this.data.data ? this.data.data[0].name : '',
          type: 'line',
          data: this.data.data ? this.data.data[0].value : '',
          symbolSize: 1,
          symbol: 'circle',
          smooth: true,
          yAxisIndex: 0,
          showSymbol: false,
          lineStyle: {
            normal: {
              color: color0,
            }
          },
          itemStyle: {
            normal: {
              color: color0,
              borderColor: color0
            }
          }
        }, {
          name: this.data.data && this.data.data[1] && this.data.data[1].name ? this.data.data[1].name + '  ' : '',
          type: 'line',
          data: this.data.data && this.data.data[1] && this.data.data[1].value ? this.data.data[1].value : '',
          symbolSize: 1,
          yAxisIndex: 1,
          symbol: 'circle',
          smooth: true,
          showSymbol: false,
          lineStyle: {
            normal: {
              color: color1
            }
          },
          itemStyle: {
            normal: {
              color: color1,
              borderColor: color1
            }
          }
        }
        ]
      };
    },
  },
}
</script>

<style scoped>

</style>
